{
  const swiper = new Swiper('.swiper', {
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });
}
